module.exports = __webpack_public_path__ + "img/onlineRetailers-Marketing3.8f4ac8e1.png";